import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageContext from '../context/LanguageContext';

/**
 * Custom hook for language operations
 * Returns language state, change function, RTL flag, and translation function
 */
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  const { t } = useTranslation();

  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }

  return {
    ...context,
    t
  };
};

export default useLanguage;
